/* =============================================================================
   CATÁLOGO DE PRECIOS MEDIOS — ANEXO I DEL BOE
   =============================================================================

   Fuente oficial:
     Orden HAC/1501/2025, de 17 de diciembre (BOE de 23/12/2025), en vigor desde
     el 1 de enero de 2026. Anexo I: "Precios medios de vehículos usados durante
     el primer año posterior a su primera matriculación".
     https://www.boe.es/buscar/doc.php?id=BOE-A-2025-26357

   Qué contiene cada registro:
     marca    String  — Marca comercial tal cual figura en el BOE (ej. 'BMW')
     modelo   String  — Denominación completa (ej. '320d Touring Business')
     periodo  String  — Periodo de comercialización (ej. '2015-2019'). Puede ser ''
     cc       Number  — Cilindrada en cm3
     cvf      Number  — Caballos fiscales
     kw       Number  — Potencia en kW
     combustible String — 'G' gasolina, 'D' diésel, 'E' eléctrico, 'H' híbrido
     co2      Number  — Emisiones oficiales de CO2 en g/km (0 si no consta)
     valor    Number  — Precio medio a nuevo en euros, IVA incluido

   IMPORTANTE — cómo se rellena este archivo:
     No se transcribe a mano. Se genera con el parser:

       node scripts/parse-boe-anexo1.js ruta/al/BOE-A-2025-26357.pdf

     que sobrescribe el array VEHICULOS_BOE de este mismo archivo. El proceso
     se repite cada mes de enero cuando el Ministerio publica la orden nueva.

   Mientras el array esté vacío, la calculadora oculta el selector de marca y
   modelo y pide el valor BOE a mano. En cuanto se cargue el catálogo, el
   selector aparece solo: el componente no necesita ningún cambio.

   ADVERTENCIA: no añadir registros inventados o estimados. Los importes de este
   archivo se presentan al usuario como valores oficiales de Hacienda y Gestoría
   Riola responde de ellos. Si un modelo no está en el BOE, la vía correcta es
   el campo manual, no una estimación.
   ========================================================================== */

/* Metadatos de la orden vigente. Se actualizan junto con el catálogo. */
export const ORDEN_BOE = {
  referencia: 'Orden HAC/1501/2025, de 17 de diciembre',
  ejercicio: 2026,
  url: 'https://www.boe.es/buscar/doc.php?id=BOE-A-2025-26357'
};

/* Catálogo del Anexo I. Generado por scripts/parse-boe-anexo1.js. */
export const VEHICULOS_BOE = [];

/* -----------------------------------------------------------------------------
   Anexo IV — porcentaje del valor a nuevo que se conserva según los años
   transcurridos desde la primera matriculación. Es la tabla de depreciación
   que Hacienda aplica tanto al ITP como al impuesto de matriculación.
   -------------------------------------------------------------------------- */
export const DEPRECIACION_ANEXO_IV = [
  { hastaAnios: 1,  porcentaje: 100 },
  { hastaAnios: 2,  porcentaje: 84 },
  { hastaAnios: 3,  porcentaje: 67 },
  { hastaAnios: 4,  porcentaje: 56 },
  { hastaAnios: 5,  porcentaje: 47 },
  { hastaAnios: 6,  porcentaje: 39 },
  { hastaAnios: 7,  porcentaje: 34 },
  { hastaAnios: 8,  porcentaje: 28 },
  { hastaAnios: 9,  porcentaje: 24 },
  { hastaAnios: 10, porcentaje: 19 },
  { hastaAnios: 11, porcentaje: 17 },
  { hastaAnios: 12, porcentaje: 13 }
];

/* Más de doce años */
export const DEPRECIACION_RESTO = 10;

/* -----------------------------------------------------------------------------
   Utilidades de consulta del catálogo
   -------------------------------------------------------------------------- */

/* Lista de marcas únicas, ordenada alfabéticamente. */
export function marcasDisponibles() {
  const vistas = {};
  const salida = [];
  VEHICULOS_BOE.forEach(function (v) {
    if (!vistas[v.marca]) {
      vistas[v.marca] = true;
      salida.push(v.marca);
    }
  });
  return salida.sort(function (a, b) { return a.localeCompare(b, 'es'); });
}

/* Modelos de una marca, listos para un v-autocomplete. */
export function modelosDeMarca(marca) {
  return VEHICULOS_BOE
    .filter(function (v) { return v.marca === marca; })
    .map(function (v, i) {
      const periodo = v.periodo ? ' (' + v.periodo + ')' : '';
      return {
        id: marca + '::' + i,
        texto: v.modelo + periodo,
        vehiculo: v
      };
    })
    .sort(function (a, b) { return a.texto.localeCompare(b.texto, 'es'); });
}

export default { ORDEN_BOE, VEHICULOS_BOE, DEPRECIACION_ANEXO_IV, DEPRECIACION_RESTO };
